// @ts-expect-error [MIGRATION-SUPPRESSION]: TS1484
import { injectIntl, IntlShape } from 'react-intl';
import React from 'react';
import { useShouldRenderBlueprint } from '../../../common/useShouldRenderBlueprint';
import VariantComponent from '../../../common/variant-component';
import BlueprintFormErrorNotification from './BlueprintFormErrorNotification';
import BuieFormErrorNotification from './BuieFormErrorNotification';

type FormErrorNotificationProps = {
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  errorMessage: any;
  intl: IntlShape;
  onClose: () => void;
};

const VariantFormErrorNotification = (props: FormErrorNotificationProps) => {
  // Should be addressed in FORMS-21229
  const shouldRenderBlueprint = useShouldRenderBlueprint();
  return (
    <VariantComponent
      {...props}
      NewComponent={BlueprintFormErrorNotification}
      OldComponent={BuieFormErrorNotification}
      shouldRenderNewComponent={shouldRenderBlueprint}
    />
  );
};

export default injectIntl(VariantFormErrorNotification);
